export default __webpack_public_path__ + "static/media/aiObjectInActive.4a0aa651.svg";